import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, AvatarWithLabel } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { PickFolderDialog } from 'app/domains/common-ui/pickers';
import { Container } from './styled';
export function SelectFolder(props) {
    const { folderName, initialFolderId, disabled, onSelect } = props;
    const [renderDialog, setRenderDialog] = useState(false);
    const showDialog = () => setRenderDialog(true);
    const hideDialog = () => setRenderDialog(false);
    const handleSubmit = (folder) => {
        onSelect(folder);
        hideDialog();
    };
    const locationLabel = t({
        comment: 'Select folder label: Location',
        message: 'Location',
    });
    return (<Fragment>
      <Container>
        <Box alignItems="center" justifyContent="space-between">
          {folderName ? (<AvatarWithLabel size="sm" appearance="light" title={folderName} subtitle={locationLabel}>
              <Falcon icon="folder"/>
            </AvatarWithLabel>) : (<AvatarWithLabel size="sm" appearance="light" title={locationLabel} subtitle={t({
                comment: 'Select folder description: No folder selected',
                message: 'No folder has been selected',
            })}>
              <Falcon icon="folder"/>
            </AvatarWithLabel>)}
          <Button size="xs" type="button" appearance={folderName ? 'ghost' : 'primary'} disabled={disabled} onClick={showDialog}>
            {folderName ? (<Trans comment="Select folder: Change location button label">Change location</Trans>) : (<Trans comment="Select folder: Pick location button label">Pick location</Trans>)}
          </Button>
        </Box>
      </Container>
      {renderDialog && (<PickFolderDialog dialogTitle={t({
                comment: 'Choose folder dialog - Choose folder title',
                message: 'Choose folder',
            })} dialogSubtitle={t({
                comment: 'Choose folder dialog - Choose folder description',
                message: 'Choose where you want to save the document',
            })} submitLabel={t({
                comment: 'Choose folder dialog - Save here button',
                message: 'Save here',
            })} initialFolderId={initialFolderId} onSubmit={handleSubmit} onClose={hideDialog}/>)}
    </Fragment>);
}
